// eslint-disable-next-line import/prefer-default-export
export const mapToSelectOptions = options =>
  Array.isArray(options) ? options.map(c => ({ name: c.label, value: c.id })) : [];
